/* eslint no-undef: 0 */

/** Import everything from autoload */
import "./autoload/jquery";
import "./autoload/modernizr";
import "./autoload/slick";

// import "./autoload/owlcarousel";
import "./autoload/aos";

/** Import everything from common */
import "./partials/faqs.js"; import "./partials/half-image-half-slider.js"; import "./partials/half-image-half-table.js"; import "./partials/header-navigation.js"; import "./partials/hero.js"; import "./partials/image-object-fit.js"; import "./partials/injury-form.js"; import "./partials/lazy-loading.js"; import "./partials/menu.js"; import "./partials/pricing-slider.js"; import "./partials/testimonial-slider.js";

// Rellax imported in app.blade.php via CDN
var rellax = new Rellax(".js-rellax");



// WEBPACK FOOTER //
// ./scripts/main.js